// @flow

import React, { Component } from 'react';
import radium from 'radium';

import school from '../static/images/Block2/school.png';

import SocialBlock from '../components/Block2/SocialBlock.jsx';
import CardBlock from '../components/Block2/CardBlock.jsx';
import AnimationBlock from '../components/Block2/AnimationBlock.jsx';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '50px 0 100px',
  },
  titleWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleBlock: {
    width: 186,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EE8356',
    borderRadius: '20px',
    color: 'white',
    fontWeight: 600,
    letterSpacing: '3px',
    position: 'relative',
    margin: '0 0 50px 107px',
    '@media (max-width: 414px)': {
      margin: '0 0 50px 60px',
    },
  },
  school: {
    position: 'absolute',
    width: 120,
    left: -100,
    bottom: -6,
    '@media (max-width: 414px)': {
      width: 80,
      left: -60,
      bottom: 2,
    },
  },
  reachStandardWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 50,
  },
  reachOuterBlock: {
    width: 540,
    height: 240,
    display: 'flex',
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 10,
    '@media(max-width: 600px)': {
      width: '100%',
    },
  },
  reachInnerBlock: {
    width: 520,
    height: 220,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#79B352',
    borderRadius: 10,
    position: 'relative',
    padding: 10,
    '@media(max-width: 600px)': {
      width: '100%',
    },
  },
  whiteDot: {
    width: 10,
    height: 10,
    borderRadius: '100%',
    backgroundColor: 'white',
    position: 'absolute',
  },
  reachTitleBlock: {
    width: 310,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EE8356',
    borderRadius: 10,
    '@media(max-width: 414px)': {
      width: 240,
    },
  },
  reachTitle: {
    color: 'white',
    fontSize: 20,
    margin: '0 10px',
    fontWeight: 600,
    '@media(max-width: 600px)': {
      fontSize: 15,
    },
  },
  greenDot: {
    width: 8,
    height: 8,
    borderRadius: '100%',
    backgroundColor: 'rgb(216, 226, 179)',
  },
  reachTimeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '15px 0',
  },
  reachTimeBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0',
  },
  reachText: {
    fontSize: 25,
    color: 'white',
    margin: '0 10px',
    '@media(max-width: 600px)': {
      fontSize: 20,
    },
    '@media(max-width: 414px)': {
      fontSize: 13,
    },
  },
  reachNumberBox: {
    width: 25,
    height: 30,
    fontSize: 23,
    color: 'white',
    backgroundColor: '#EE8356',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 3,
    fontWeight: 600,
    '@media(max-width: 600px)': {
      fontSize: 18,
    },
    '@media(max-width: 414px)': {
      width: 20,
      height: 25,
      fontSize: 11,
    },
  },
  mentionText: {
    margin: 0,
    color: '#8F5827',
    '@media (max-width: 414px)': {
      fontSize: 13,
    },
  },
};

type Props = {
  likes: Number,
  shares: Number,
  comments: Number,
};

class Block2 extends Component<Props> {
  render() {
    const {
      likes,
      shares,
      comments,
    } = this.props;

    const totalScore = likes + shares + comments;
    const remainScore = 100000 - totalScore > 0 ? 100000 - totalScore : 0;

    const splitedScore = totalScore.toString().split('');
    const splitedRemainScore = remainScore.toString().split('');

    if (splitedScore && splitedScore.length < 6) {
      let i = 0;
      const remainBlock = 6 - splitedScore.length;

      for (i; i < remainBlock; i += 1) {
        splitedScore.unshift('0');
      }
    }

    if (splitedRemainScore && splitedRemainScore.length < 6) {
      let i = 0;
      const remainBlock = 6 - splitedRemainScore.length;

      for (i; i < remainBlock; i += 1) {
        splitedRemainScore.unshift('0');
      }
    }

    return (
      <div style={styles.wrapper}>
        <div style={styles.titleWrapper}>
          <div style={styles.titleBlock}>
            <img style={styles.school} src={school} alt="學校" />
            百校贈球計畫
          </div>
        </div>
        <div style={styles.reachStandardWrapper}>
          <div style={styles.reachOuterBlock}>
            <div style={styles.reachInnerBlock}>
              <div style={[styles.whiteDot, { left: 10, top: 10 }]} />
              <div style={[styles.whiteDot, { right: 10, top: 10 }]} />
              <div style={[styles.whiteDot, { right: 10, bottom: 10 }]} />
              <div style={[styles.whiteDot, { left: 10, bottom: 10 }]} />
              <div style={styles.reachTitleBlock}>
                <div style={styles.greenDot} />
                <p style={styles.reachTitle}>
                  HOME RUN TAIWAN FIELD
                </p>
                <div style={styles.greenDot} />
              </div>
              <div style={styles.reachTimeWrapper}>
                <div style={styles.reachTimeBlock}>
                  <p style={styles.reachText}>
                    已達到
                  </p>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[0]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[1]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[2]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[3]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[4]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedScore[5]}
                  </div>
                  <p style={styles.reachText}>
                    次互動
                  </p>
                </div>
                <div style={styles.reachTimeBlock}>
                  <p style={styles.reachText}>
                    還剩下
                  </p>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[0]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[1]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[2]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[3]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[4]}
                  </div>
                  <div style={styles.reachNumberBox}>
                    {splitedRemainScore[5]}
                  </div>
                  <p style={styles.reachText}>
                    就達標
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p style={styles.mentionText}>
          因臉書政策影響，互動數量將於每日 00:00 更新
        </p>
        <AnimationBlock
          currentScore={totalScore} />
        <SocialBlock
          comments={comments}
          shares={shares}
          likes={likes} />
        <CardBlock />
      </div>
    );
  }
}

export default radium(Block2);
